import { useEffect } from 'react'
import { setupFormInputStartTracking } from '../../../src/form_input_start_tracking_core'

const useFormInputStartTracking = () => {
  useEffect(() => {
    // 共通ロジックを使用してイベントトラッキングを設定
    const cleanup = setupFormInputStartTracking()

    // コンポーネントのアンマウント時にクリーンアップを実行
    return cleanup
  }, [window.location.pathname])
}

export default useFormInputStartTracking
